function get({ path = '/reports', params }) {
  return this.axios.get(path, { params })
}

const reports = (axios) => ({ axios, get })

export default reports
